import { useQuery } from '@tanstack/react-query';

import { doGet } from 'api/request';
import { LOGGER_TYPE } from 'api/types';

export interface IntegrationAction {
  id: string;
  display_name: string;
  description: string;
  function_name: string;
  category: string;
}

export interface IntegrationProviderConfig {
  id: string;
  actions: IntegrationAction[];
}

export interface IntegrationConfigResponse {
  providers: IntegrationProviderConfig[];
  categories: string[];
}

// Fetch the static integration config from jupiter_api
export const useIntegrationConfig = () => {
  return useQuery<IntegrationConfigResponse>({
    queryKey: ['integrationConfig'],
    queryFn: async () => {
      return doGet<IntegrationConfigResponse>(
        'integration-config',
        LOGGER_TYPE.JUPITER,
        { version: 'v2' },
      );
    },
    staleTime: 1000 * 60 * 10, // Cache for 10 minutes
  });
};

export const buildIntegrationDisplayNamesMap = (
  integrationConfig: IntegrationConfigResponse | undefined,
): Record<string, Record<string, string>> => {
  if (!integrationConfig) {
    return {};
  }

  const displayNamesMap: Record<string, Record<string, string>> = {};

  integrationConfig.providers.forEach(provider => {
    displayNamesMap[provider.id] = {};
    provider.actions.forEach(action => {
      displayNamesMap[provider.id][action.function_name] = action.display_name;
    });
  });

  return displayNamesMap;
};
